import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import DashboardSkeleton from "../components/skeleton/DashboardView/dashboardSkeleton";

const ProtectedRoute = (props: any) => {
  const { Component } = props;
  const navigate = useNavigate();
  const { username } = useParams();
  const { session } = useAuth();
  const [isAuthorized, setIsAuthorized] = useState<boolean | null>(null);

  useEffect(() => {
    const loggedIn = localStorage.getItem("loggedIn");

    if (!loggedIn && !session) {
      setIsAuthorized(false);
      navigate("/");
      return;
    }

    if (username && loggedIn && loggedIn !== username) {
      setIsAuthorized(false);
      navigate("/");
      return;
    }

    // Same gates as before, without the 1s timeout that could false-logout
    // on PWA cold start while auth context is still hydrating.
    setIsAuthorized(true);
  }, [session, username, navigate]);

  // Auth still hydrating, or redirect in flight — no skeleton flash.
  if (isAuthorized !== true) {
    return null;
  }

  return (
    <div>
      <Component />
    </div>
  );
};

export default ProtectedRoute;
